import React, {useEffect, useState} from 'react';
import ResizableBox from "../../utils/ResizableBox";
import {Bar} from "react-chartjs-2";
import axios from "axios";
import {BASE_NAME} from "../../../../../services/utils/ApiUrls";
import moment from "moment";
import {getConfig} from "../../../../../services/utils/ConfigUtils";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {Backdrop, Card, CardContent, CardHeader, CircularProgress, Typography} from "@mui/material";
import clsx from "clsx";
import {colors, tipologieQuarantena} from "../../../../../utils/arrays/Generics";

const options = {
	responsive: true,
	plugins: {
		legend: {
			position: 'top',
		},
		title: {
			display: true,
			text: 'Numero di ordinanze per giorno suddivise per tipo',
		},
	},
};

export const QuaranteneGiornoStato = () => {
	const classes = BaseStyle();
	const [dataGrafico, setDataGrafico] = useState(new Date());
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({
		labels: ['01/12/2021'],
		datasets: [
			{
				label: 'I love you',
				data: [3000],
				backgroundColor: 'rgba(255, 99, 132, 0.5)',
				stack: 'Stack 0',
			},
		],
	})
	
	useEffect(() => {
		setDataGrafico(new Date())
	}, [])
	
	useEffect(() => {
		setLoading(true);
		axios
			.get(BASE_NAME + "gestionePazienti/quarantene/getStatsByDayAndType/" + moment(dataGrafico).format("DD-MM-YYYY"), getConfig())
			.then((response) => {
				let newData1 = {
					labels: response.data.map(item => moment(new Date(item.label)).format("DD/MM/YYYY")),
					datasets:
						tipologieQuarantena.map((tipo, index) => {
							return {
								label: tipo,
								data: response.data.map(elem => elem.data[tipo]),
								backgroundColor: colors[index],
								stack: 'Stack 0',
							}
						})
				}
				
				setData(newData1);
				setLoading(false)
				console.log(response.data)
			})
			.catch((error) => {
				setLoading(false);
				console.log(JSON.stringify(error))
			})
	}, [dataGrafico])
	
	return (
		<React.Fragment>
			<Backdrop open={loading} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
			
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Numero di ordinanze per giorno</b></Typography>}
					subheader={"Numero di quarantene (asse y) per giorno (asse x) suddivisi per tipo (colore)"}
				/>
				<CardContent style={{flexGrow: 1, overflow: "scroll"}}>
					
					<ResizableBox width={1200} height={600}>
						<Bar options={options} data={data} type={"bar"}/>
					</ResizableBox>
				
				</CardContent>
			</Card>
		</React.Fragment>
	);
};
